module.exports = __webpack_public_path__ + "img/BR-R4U-Logo_Negativ.e5582624.png";